import AttachmentButton from './AttachmentButton';

export default AttachmentButton;



// WEBPACK FOOTER //
// ./src/components/AttachmentButton/index.js